import React from "react";
import Page from "./components/Page";

export default function PageNotFound() {
  return <Page title="Error">404 Page Not Found</Page>;
}
